/* The welcome popup, A (simple) vs B (quiz), split 50/50 (sections/tame-popup, popup-quiz-1102). Loaded with defer, no globals.
   Spec + binding staff reshape: ~/.claude/specs/tame-shopify-horizon/popup-quiz-1102.md.

   Arm: drawn once, when the visitor first becomes eligible (consent settled, 5 s in, every never-show rule passed) or at the
   first open, whichever is first; never on page load. crypto.getRandomValues, the photo preloaded then, kept in tame_popup_ab
   {arm, at, seen:{A,B}, mail:{A,B}}. test_mode a|b forces everyone. Storage blocked: arm A, tab only (no auto-open), source
   'welcome-popup-a-nostore', no GA4 test events. Preview only (unpublished/development theme): ?popup_arm=a|b forces the arm and
   ?popup=preview opens at once; neither writes storage.
   Sign-up: POST {email, source:'welcome-popup-a'|'welcome-popup-b'} (B adds variant + answers, which today's handler ignores) to
   data-endpoint (Dale's api/tame-welcome-subscribe). Never a phone key on the email post. Code prints only on 200 {ok:true}.
   Auto-open (all need: enabled, not joined, not creator/own-email traffic, Consentmo quiet, 3 opens max, 3-day second chance,
   no session snooze, cart EMPTY, no other layer open, 30 s quiet after any buy-box touch, not the paid LP):
     product pages  under 990px: scrolled past the Add button AND pdp_seconds; 990px up: exit intent (after 6 s) OR that rule
     other pages    under 750px: auto_seconds_phone AND 25% scroll; 750-989px: auto_seconds_desktop AND 25% scroll;
                    990px up: exit intent (after 6 s) OR auto_seconds_desktop
   Cart: data-cart-count from Liquid, then shopify:cart:lines-update (add = has items at once; else the event's promise
   cart.totalQuantity, or one /cart.js read), and /cart.js again on a bfcache return. Never a cookie test.
   Scroll: document capture listener; .page-wrapper scrolls from 990px (Horizon), so it is read there.
   Tab (.tpop-tab, kept so tame-overrides R14-A3 still hides it on phone product pages): phones, hidden at rest, slides in on a
   scroll up of 8px+ after 300px or near the page end, hides 2.5 s after scrolling stops or on any scroll down. 750px up: after
   5 s, bottom-left, moves right or hides when it would cover a preset card, the builder button, a bottom bar or the cart button.
   Its bottom sits 8px above any visible bottom bar. Tucked = inert + visibility hidden.
   Events: GA4 (dataLayer, consent-gated like snippets/tame-analytics) popup_<arm>_view once per browser per arm, popup_<arm>_email
   once at joined, B diagnostics popup_b_q1/q2/skip/result/build_click. The existing series carry the arm too: dataLayer
   popup_view (once per session) and popup_email, and Shopify.analytics popup_view / popup_submit (once per session; tame.js
   no longer binds them because this dialog is data-tpab-dialog). Every param set has arm, trigger and template.
   W29 handshake kept: window.tamePopupOn + html[data-tame-popup-on] stand the old exit modal down. */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-tpab-dialog]');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  var params = new URLSearchParams(window.location.search);
  var preview = dlg.getAttribute('data-demo') === 'true';
  var demo = preview && params.get('popup') === 'preview';
  var rules = preview && params.get('popup') === 'rules';
  var forced = preview ? String(params.get('popup_arm') || '').toUpperCase() : '';
  if (forced !== 'A' && forced !== 'B') forced = '';
  var enabled = dlg.getAttribute('data-enabled') === 'true' || rules;
  if (enabled || demo || forced) { window.tamePopupOn = true; document.documentElement.setAttribute('data-tame-popup-on', ''); }

  var KEY = 'tame_popup', ABKEY = 'tame_popup_ab';
  var DAY = 86400000, RESHOW = 3 * DAY, MAX_OPENS = 3, QUIET_MS = 30000;
  var num = function (a, d) { var n = parseInt(dlg.getAttribute(a), 10); return Math.max(6, isNaN(n) ? d : n); };
  var phoneS = num('data-auto-phone', 15), deskS = num('data-auto-desktop', 20), pdpS = num('data-pdp-seconds', 20);
  var tpl = dlg.getAttribute('data-template') || '';
  var isPdp = tpl === 'product';
  var endpoint = dlg.getAttribute('data-endpoint') || '';
  var consentSel = dlg.getAttribute('data-consent') || '';
  var code = dlg.getAttribute('data-code') || '';
  var buildUrl = dlg.getAttribute('data-build-url') || '/pages/build-your-routine';
  var smsOn = dlg.getAttribute('data-sms') === '1';
  var slot = dlg.querySelector('[data-tpab-slot]');
  var tab = document.querySelector('[data-tpop-tab]');
  var t0 = Date.now();

  /* storage, every read and write guarded */
  var storageOk = (function () { try { var k = '__tpab'; window.localStorage.setItem(k, '1'); window.localStorage.removeItem(k); return true; } catch (e) { return false; } })();
  var lsGet = function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } };
  var lsSet = function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* no storage */ } };
  var session = function (k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      if (v === null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v);
    } catch (e) { return null; }
    return v;
  };
  var write = !demo && !forced; /* test views never write */
  function state() {
    var raw = lsGet(KEY) || '';
    if (raw === 'done') return { joined: true };
    if (raw.indexOf('closed:') === 0) { var t = parseInt(raw.slice(7), 10); return isNaN(t) ? {} : { dismissedAt: t }; }
    try { var o = JSON.parse(raw); return (o && typeof o === 'object' && !Array.isArray(o)) ? o : {}; } catch (e) { return {}; }
  }
  function save(st) { if (write) lsSet(KEY, JSON.stringify(st)); }
  function abRec() {
    var raw = lsGet(ABKEY) || '';
    if (raw === 'A' || raw === 'B') return { arm: raw };
    try { var o = JSON.parse(raw); if (o && typeof o === 'object' && !Array.isArray(o)) return o; } catch (e) { /* fresh */ }
    return {};
  }
  function abSave(r) { if (write && storageOk) lsSet(ABKEY, JSON.stringify(r)); }

  var hasCookie = function (name) {
    try { return document.cookie.split(';').some(function (c) { return c.trim().indexOf(name + '=') === 0; }); } catch (e) { return false; }
  };
  var visible = function (el) {
    if (!el) return false;
    var r = el.getBoundingClientRect(); var cs = window.getComputedStyle(el);
    return r.width > 0 && r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05;
  };
  var mqPhone = window.matchMedia('(max-width: 749px)'), mqWide = window.matchMedia('(min-width: 990px)');

  /* ---------- the arm ---------- */
  var arm = '', nostore = false;
  function drawArm() {
    if (arm) return arm;
    var mode = (dlg.getAttribute('data-test-mode') || 'split').toLowerCase();
    if (forced) arm = forced;
    else if (mode === 'a' || mode === 'b') arm = mode.toUpperCase();
    else if (!storageOk) { arm = 'A'; nostore = true; }
    else {
      var r = abRec();
      if (r.arm === 'A' || r.arm === 'B') arm = r.arm;
      else if (demo) arm = 'A';
      else {
        var bit;
        try { var u = new Uint8Array(1); window.crypto.getRandomValues(u); bit = u[0] & 1; } catch (e) { bit = Math.random() < 0.5 ? 0 : 1; }
        arm = bit ? 'B' : 'A';
        r.arm = arm; r.at = Date.now(); abSave(r);
      }
    }
    try { new Image().src = dlg.getAttribute(arm === 'B' ? 'data-photo-b' : 'data-photo-a'); } catch (e) { /* preload is a nicety */ }
    return arm;
  }
  var source = function () { return 'welcome-popup-' + arm.toLowerCase() + (nostore ? '-nostore' : ''); };

  /* ---------- events ---------- */
  function analyticsYes() {
    try { var p = window.Shopify && window.Shopify.customerPrivacy; return !!(p && navigator.globalPrivacyControl !== true && p.analyticsProcessingAllowed()); } catch (e) { return false; }
  }
  var lastTrigger = 'tab';
  function ga(name, extra) {
    if (nostore || !analyticsYes()) return;
    try {
      var p = { popup: 'welcome', arm: arm, trigger: lastTrigger, template: tpl };
      if (preview) p.preview = 1; /* dev and unpublished themes: filter these out of the A/B read */
      if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
      window.dataLayer = window.dataLayer || [];
      (function gtag() { window.dataLayer.push(arguments); })('event', name, p);
    } catch (e) { /* analytics never breaks the pop-up */ }
  }
  var pubOnce = {};
  function publish(name) {
    var key = 'tame_popup_' + name + '_' + arm;
    if (pubOnce[key] || session(key) || !analyticsYes()) return;
    pubOnce[key] = 1; session(key, '1');
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, { offer: 'email_15', arm: nostore ? 'A-nostore' : arm, trigger: lastTrigger, preview: preview ? 1 : 0 }); } catch (e) { /* never block */ }
  }
  /* the existing GA4 series (theme dataLayer, W28: the pixel does not forward the popup events): popup_view once per session,
     popup_email at each sign-up, both now carrying the arm in their params */
  function gaSession(name) {
    var key = 'tame_popup_ga_' + name + '_' + arm;
    if (pubOnce[key] || session(key) || nostore || !analyticsYes()) return;
    pubOnce[key] = 1; session(key, '1'); ga(name);
  }
  function onceGa(kind) { /* popup_<arm>_view / _email: once per browser per arm */
    var r = abRec(); var bucket = kind === 'view' ? 'seen' : 'mail';
    r[bucket] = r[bucket] && typeof r[bucket] === 'object' ? r[bucket] : {};
    if (r[bucket][arm]) return;
    if (!analyticsYes() || nostore) return;
    r[bucket][arm] = 1; abSave(r);
    ga('popup_' + arm.toLowerCase() + '_' + kind);
  }

  /* ---------- build the drawn arm into the dialog ---------- */
  var built = false, view = null;
  function build() {
    if (built) return;
    var tmpl = document.querySelector('template[data-tpab-arm="' + arm + '"]');
    if (!tmpl || !slot) return;
    slot.appendChild(tmpl.content.cloneNode(true));
    dlg.classList.add('tpab--' + arm.toLowerCase());
    built = true;
    view = arm === 'B' ? quiz() : simple();
  }

  /* ---------- open / close ---------- */
  var lastFocus = null;
  function otherLayerOpen() {
    return !!document.querySelector('dialog[open]:not([data-tpab-dialog]), [data-exit].is-open, cart-drawer[open], .cart-drawer[open], details[open].cart-drawer, .mnav.is-open') || document.documentElement.style.overflow === 'hidden';
  }
  function focusEl(el) { if (el && typeof el.focus === 'function') { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } } }
  function open(trigger) {
    if (dlg.open) return false;
    drawArm(); build();
    if (!view) return false;
    lastTrigger = trigger || 'tab';
    lastFocus = document.activeElement;
    try { dlg.showModal(); } catch (e) { return false; }
    tabShow(false);
    view.opened();
    onceGa('view'); gaSession('popup_view'); publish('popup_view');
    return true;
  }
  dlg.addEventListener('close', function () {
    var st = state();
    if (!st.joined) { st.dismissedAt = Date.now(); save(st); if (write) session('tame_popup_snooze', '1'); }
    else if (tab) tab.hidden = true;
    /* focus goes back to the opener; the tab is brought back first so it can take it. A hidden opener sends focus to main. */
    var fromTab = !!(lastFocus && tab && tab.contains(lastFocus));
    if (fromTab && !st.joined) tabShow(true, true);
    var back = null;
    /* the tab only takes focus if it is really visible (a joined visitor's tab is hidden); else the pre-open element, else main */
    if (fromTab) back = (tabOn && !tab.hidden && visible(lastFocus)) ? lastFocus : null;
    else if (lastFocus && lastFocus !== document.body && document.contains(lastFocus) && visible(lastFocus) && !lastFocus.closest('[inert],[hidden]')) back = lastFocus;
    if (!back) { back = document.querySelector('main') || document.getElementById('MainContent'); if (back && !back.hasAttribute('tabindex')) back.setAttribute('tabindex', '-1'); }
    focusEl(back);
    if (!st.joined) tabSoon();
  });
  function close() { if (dlg.open) dlg.close(); }
  dlg.querySelectorAll('[data-tpab-close]').forEach(function (b) { b.addEventListener('click', close); });
  var downOnBackdrop = false;
  dlg.addEventListener('mousedown', function (e) { downOnBackdrop = e.target === dlg; });
  dlg.addEventListener('click', function (e) { if (e.target === dlg && downOnBackdrop) close(); });
  /* focus trap: Tab and Shift+Tab wrap inside the dialog (WebKit skips buttons by default, so the wrap is manual) */
  function focusables() {
    return Array.prototype.filter.call(dlg.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden])'), function (x) { return visible(x) && !x.closest('[hidden]'); });
  }
  /* Tab and Shift+Tab are moved by hand on every press: WebKit skips buttons and links by default, so a trap that only
     catches the two ends lets focus fall out of the dialog after the email field */
  dlg.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    e.preventDefault();
    var i = f.indexOf(document.activeElement);
    var next = i === -1 ? (e.shiftKey ? f.length - 1 : 0) : (i + (e.shiftKey ? -1 : 1) + f.length) % f.length;
    focusEl(f[next]);
  });

  /* ---------- shared form pieces ---------- */
  var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;
  function setErr(form, kind) {
    var err = form.querySelector('[data-tpab-err]'); var input = form.querySelector('input[type=email]');
    if (!err) return;
    err.textContent = kind ? (kind === 'email' ? err.getAttribute('data-msg-email') : err.getAttribute('data-msg-server')) : '';
    if (input) { if (kind) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
  }
  function post(body) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = window.setTimeout(function () { if (ctl) ctl.abort(); }, 15000);
    return window.fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { return { ok: false }; }); })
      .then(function (res) { window.clearTimeout(timer); return !!(res.ok && res.j && res.j.ok === true); }, function () { window.clearTimeout(timer); return false; });
  }
  function bindForm(form, bodyFn, onJoined) {
    var input = form.querySelector('input[type=email]'); var btn = form.querySelector('[data-tpab-submit]');
    if (input) input.addEventListener('input', function () { if (input.getAttribute('aria-invalid')) setErr(form, ''); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!input || !btn || btn.disabled) return;
      setErr(form, '');
      var email = (input.value || '').trim();
      if (email.length > 254 || !EMAIL.test(email)) { setErr(form, 'email'); focusEl(input); return; }
      publish('popup_submit');
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'One sec';
      post(bodyFn(email)).then(function (ok) {
        btn.disabled = false; btn.textContent = label;
        if (!ok) { setErr(form, 'server'); focusEl(input); return; }
        var st = state(); st.joined = true; save(st);
        if (tab) tab.hidden = true;
        onceGa('email'); ga('popup_email');
        onJoined(email);
      });
    });
  }
  function bindCopy(scope) {
    scope.querySelectorAll('[data-tpab-copy]').forEach(function (b) {
      var label = b.textContent; var live = b.parentNode.querySelector('[data-tpab-copied]');
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-tpab-copy') || '';
        var done = function () { b.textContent = 'Copied'; if (live) live.textContent = 'Code copied'; window.setTimeout(function () { b.textContent = label; if (live) live.textContent = ''; }, 2000); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(c).then(done, done); else done();
      });
    });
  }
  /* the text step: only in the DOM when the setting is on; a second post, after the email has already succeeded */
  function bindSms(scope, getEmail) {
    if (!smsOn) return;
    scope.querySelectorAll('[data-tpab-sms]').forEach(function (box) {
      var opener = box.querySelector('[data-tpab-sms-open]'); var form = box.querySelector('[data-tpab-sms-form]');
      if (!opener || !form) return;
      opener.addEventListener('click', function () { form.hidden = false; opener.setAttribute('aria-expanded', 'true'); opener.hidden = true; focusEl(form.querySelector('input')); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var tel = form.querySelector('input[type=tel]'); var err = form.querySelector('[data-tpab-sms-err]'); var btn = form.querySelector('button[type=submit]');
        var digits = String(tel && tel.value || '').replace(/\D/g, '');
        if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
        if (digits.length !== 10) { if (err) err.textContent = err.getAttribute('data-msg') || ''; if (tel) { tel.setAttribute('aria-invalid', 'true'); focusEl(tel); } return; }
        if (err) err.textContent = ''; if (tel) tel.removeAttribute('aria-invalid');
        if (btn) btn.disabled = true;
        post({ email: getEmail(), phone: digits, source: source(), sms_consent_v: dlg.getAttribute('data-sms-v') || '' }).then(function (ok) {
          if (btn) btn.disabled = false;
          if (!ok) { if (err) err.textContent = 'Something hiccuped. Try once more.'; return; }
          var d = form.querySelector('[data-tpab-sms-done]'); if (d) d.hidden = false;
          if (btn) btn.hidden = true;
          ga('popup_' + arm.toLowerCase() + '_phone');
        });
      });
    });
  }
  function label(id) { if (id) dlg.setAttribute('aria-labelledby', id); }

  /* ---------- A: simple ---------- */
  function simple() {
    var asks = slot.querySelectorAll('[data-tpab-state="ask"]'), oks = slot.querySelectorAll('[data-tpab-state="ok"]');
    var form = slot.querySelector('[data-tpab-form]'); var email = '';
    bindCopy(slot); bindSms(slot, function () { return email; });
    var joinedView = function () {
      asks.forEach(function (n) { n.hidden = true; }); oks.forEach(function (n) { n.hidden = false; });
      label('tpab-h-a-ok'); focusEl(slot.querySelector('#tpab-h-a-ok'));
    };
    if (form) bindForm(form, function (em) { email = em; return { email: em, source: source(), variant: 'A' }; }, joinedView);
    if (state().joined && form) { asks.forEach(function (n) { n.hidden = true; }); oks.forEach(function (n) { n.hidden = false; }); }
    return { opened: function () { var ok = slot.querySelector('[data-tpab-state="ok"]:not([hidden]) h2'); var h = ok || slot.querySelector('#tpab-h-a'); label(h && h.id); window.setTimeout(function () { focusEl(h); }, 30); } };
  }

  /* ---------- B: quiz ---------- */
  function quiz() {
    var kit = {};
    try { kit = JSON.parse((slot.querySelector('[data-tpab-kit]') || {}).textContent || '{}'); } catch (e) { kit = {}; }
    var scr = {}; slot.querySelectorAll('[data-scr]').forEach(function (n) { scr[n.getAttribute('data-scr')] = n; });
    var stepLive = slot.querySelector('[data-tpab-step]');
    var q = { problem: '', hair: '', result: '', joined: false, email: '' };
    var trail = [];
    var cur = 'q1';
    var say = { q1: 'Question 1 of 2', q2: 'Question 2 of 2', email: 'Email', result: 'Your kit' };
    function go(name, back) {
      if (!scr[name]) return;
      if (!back && cur !== name) trail.push(cur);
      Object.keys(scr).forEach(function (k) { scr[k].hidden = k !== name; });
      cur = name;
      var h = scr[name].querySelector('h2'); label(h && h.id);
      if (stepLive) stepLive.textContent = say[name] || '';
      dlg.setAttribute('data-scr', name);
      window.setTimeout(function () { focusEl(h); }, 30);
    }
    function back() { var p = trail.pop(); if (p) go(p, true); }
    slot.querySelectorAll('[data-tpab-back]').forEach(function (b) { b.addEventListener('click', back); });
    slot.querySelectorAll('[data-q1]').forEach(function (b) {
      b.addEventListener('click', function () { q.problem = b.getAttribute('data-q1'); q.result = (kit.route && kit.route[q.problem]) || q.problem; ga('popup_b_q1', { answer: q.problem }); go('q2'); });
    });
    slot.querySelectorAll('[data-q2]').forEach(function (b) {
      b.addEventListener('click', function () { q.hair = b.getAttribute('data-q2'); ga('popup_b_q2', { answer: q.hair }); if (q.joined) { result(); go('result'); } else go('email'); });
    });
    var form = scr.email && scr.email.querySelector('[data-tpab-form]');
    if (form) bindForm(form, function (em) {
      q.email = em;
      var body = { email: em, source: source(), variant: 'B' };
      if (q.problem) body.answers = { problem: q.problem, hair_type: q.hair || '', result: q.result };
      return body;
    }, function () { q.joined = true; trail = trail.filter(function (x) { return x !== 'email'; }); result(); go('result'); });
    var skip = slot.querySelector('[data-tpab-skip]');
    if (skip) skip.addEventListener('click', function () { ga('popup_b_skip'); result(); go('result'); });
    var addEmail = slot.querySelector('[data-tpab-add-email]');
    if (addEmail) addEmail.addEventListener('click', function () { go('email'); });
    var build = slot.querySelector('[data-tpab-build]');
    var plain = function () { return buildUrl + '?preset=' + encodeURIComponent(q.result || 'frizz') + '&pv=B'; };
    /* Live read 11/02: /discount/CODE?redirect=<builder>?preset=... drops the query, so the kit was not preselected (review 15
       fallback). After a real sign-up the click applies the code with one fetch, then opens the builder with ?preset=. */
    if (build) build.addEventListener('click', function (e) {
      ga('popup_b_build_click', { result: q.result });
      if (!(q.joined && code) || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      var to = plain(); var gone = false; var go2 = function () { if (!gone) { gone = true; window.location.href = to; } };
      window.setTimeout(go2, 4000);
      window.fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' }).then(go2, go2);
    });
    bindCopy(slot); bindSms(slot, function () { return q.email; });
    function result() {
      var id = q.result || 'frizz';
      var t = slot.querySelector('[data-tpab-r-title]'); if (t) t.textContent = (kit.title && kit.title[id]) || '';
      var hk = slot.querySelector('[data-tpab-r-hook]'); if (hk) { hk.textContent = (kit.hook && kit.hook[id]) || ''; hk.hidden = !hk.textContent; }
      var ct = slot.querySelector('[data-tpab-r-contents]');
      if (ct) { /* each piece on one line: "Fine Mister" never splits */
        var parts = String((kit.contents && kit.contents[id]) || '').split(' \u00b7 ').filter(Boolean);
        ct.textContent = '';
        parts.forEach(function (p, i) { var sp = document.createElement('span'); sp.textContent = p; ct.appendChild(sp); if (i < parts.length - 1) ct.appendChild(document.createTextNode(' \u00b7 ')); });
        ct.hidden = !parts.length;
      }
      var j = slot.querySelector('[data-tpab-r-joined]'); if (j) j.hidden = !q.joined;
      var fine = slot.querySelector('[data-tpab-r-fine]'); if (fine) fine.hidden = !q.joined;
      if (addEmail) addEmail.hidden = q.joined;
      /* the code goes on the link only after a real sign-up, and only while the surface is live (apply_code) */
      if (build) build.href = plain();
      ga('popup_b_result', { result: id });
    }
    if (state().joined) q.joined = true;
    return { opened: function () { go(cur, true); } };
  }

  /* ---------- who never sees it ---------- */
  if (!endpoint || !slot) return;
  if (params.has('creator') || params.has('c') || hasCookie('tame_c')) return;
  if (/^(email|sms)$/i.test(params.get('utm_medium') || '') || /^klaviyo$/i.test(params.get('utm_source') || '') || params.has('_kx')) session('tame_popup_own', '1');
  if (!demo && !forced) {
    if (!enabled) return;
    if (state().joined) return;
    if (session('tame_popup_own')) return;
  }

  /* ---------- Consentmo first: wait while its banner shows, at most 30 seconds ---------- */
  function bannerShowing() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) {
        var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
        var decided = !!(c && (c.marketing || c.analytics || c.preferences || c.sale_of_data)) || hasCookie('cookieconsent_status') || hasCookie('cookieconsent_preferences_disabled');
        if (!decided) return true;
      }
    } catch (e) { /* no API: fall through to the element */ }
    try {
      var hosts = consentSel ? document.querySelectorAll(consentSel) : [];
      var isBar = function (n) { if (!visible(n)) return false; var r = n.getBoundingClientRect(); return r.width >= 200 && r.height >= 60; };
      return Array.prototype.some.call(hosts, function (el) {
        if (el.shadowRoot && Array.prototype.some.call(el.shadowRoot.querySelectorAll('*'), isBar)) return true;
        return isBar(el);
      });
    } catch (e) { return false; }
  }
  function whenConsentQuiet(cb) {
    var started = Date.now(); var finished = false;
    var onCollect = function () { window.setTimeout(finish, 300); };
    var finish = function () { if (finished) return; finished = true; document.removeEventListener('visitorConsentCollected', onCollect); cb(); };
    document.addEventListener('visitorConsentCollected', onCollect);
    (function poll() {
      if (finished) return;
      if (!bannerShowing()) return finish();
      if (Date.now() - started > 30000) { finished = true; document.removeEventListener('visitorConsentCollected', onCollect); return; }
      window.setTimeout(poll, 500);
    })();
  }

  if (demo) { window.setTimeout(function () { whenConsentQuiet(function () { open('preview'); }); }, 1500); }

  /* ---------- the page's scroll (Horizon scrolls .page-wrapper from 990px) ---------- */
  var wrap = document.querySelector('.page-wrapper');
  function scrollInfo() {
    var doc = document.documentElement;
    var useWrap = wrap && mqWide.matches && wrap.scrollHeight > wrap.clientHeight + 10;
    var y = useWrap ? wrap.scrollTop : (window.scrollY || doc.scrollTop || 0);
    var max = Math.max(1, useWrap ? wrap.scrollHeight - wrap.clientHeight : doc.scrollHeight - window.innerHeight);
    return { y: y, max: max };
  }
  var scrollFns = [];
  var rafQ = false;
  document.addEventListener('scroll', function () {
    if (rafQ) return; rafQ = true;
    window.requestAnimationFrame(function () { rafQ = false; var s = scrollInfo(); scrollFns.forEach(function (fn) { fn(s); }); });
  }, { capture: true, passive: true });

  /* ---------- the cart: item count, never a cookie ---------- */
  var cartCount = parseInt(dlg.getAttribute('data-cart-count'), 10) || 0;
  function readCart() {
    return window.fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (c) { if (c && typeof c.item_count === 'number') cartCount = c.item_count; }, function () { /* keep the last count */ });
  }
  document.addEventListener('shopify:cart:lines-update', function (e) {
    var action = e && (e.action || (e.detail && e.detail.action));
    if (action === 'add') cartCount = Math.max(cartCount, 1);
    var p = e && (e.promise || (e.detail && e.detail.promise));
    if (p && typeof p.then === 'function') {
      p.then(function (r) { if (r && r.cart && typeof r.cart.totalQuantity === 'number') cartCount = r.cart.totalQuantity; else return readCart(); }, function () { return readCart(); });
    } else if (action !== 'add') readCart();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) readCart(); });

  /* ---------- buy-box touches: a 30 s quiet window ---------- */
  var lastBuy = 0;
  var BUY = '[data-tame-buy], form[data-type="add-to-cart-form"], product-form, .buy-buttons-block, [data-sticky], [data-bbar], .bbar, [data-builder]';
  ['click', 'change', 'input'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (!(e.target && e.target.closest && e.target.closest(BUY)) || e.target.closest('[data-tpab-dialog], [data-tpop-tab]')) return;
      lastBuy = Date.now();
      window.setTimeout(watchBuy, 60); /* after the buy box has swapped which button shows */
    }, true);
  });

  /* ---------- scrolled past the Add button (product pages): the same targets tame.js stickyTarget() watches ---------- */
  var pastBuy = false;
  function buyTarget() {
    var box = document.querySelector('[data-tame-buy]');
    var vis = function (el) { return el && el.offsetParent !== null; };
    if (box) {
      var hornForm = document.querySelector('form[data-type="add-to-cart-form"]');
      var horn = hornForm && hornForm.closest('.buy-buttons-block, [class*="buy-buttons"]');
      var hbtn = horn && horn.querySelector('button[type="submit"], [name="add"], .add-to-cart-button');
      var cands = [hbtn, box.querySelector('[data-routine-add]')].concat(Array.prototype.slice.call(box.querySelectorAll('[data-when]:not([hidden]) [data-tame-add]')), [box.querySelector('#notify input[type="email"]')]);
      for (var i = 0; i < cands.length; i++) if (vis(cands[i])) return cands[i];
      return box;
    }
    return document.querySelector('form[data-type="add-to-cart-form"] button[type="submit"]') || document.querySelector('form[data-type="add-to-cart-form"]');
  }
  /* Diff review P1-2: picking Subscribe hides Horizon's button (.tame-hide-buy), and a hidden element reads as off screen. So the
     button is re-picked after every buy-box change, and only a laid-out button (width > 0) scrolled above the top counts. */
  var buyIO = null, buyEl = null;
  function watchBuy() {
    if (!isPdp || !('IntersectionObserver' in window)) return;
    var t = buyTarget();
    if (t === buyEl) return;
    if (buyIO && buyEl) buyIO.unobserve(buyEl);
    buyEl = t;
    if (!buyIO) buyIO = new IntersectionObserver(function () { pastBuy = isPast(); check(); }, { root: null, threshold: 0 });
    if (buyEl) buyIO.observe(buyEl);
  }
  function isPast() { var r = buyEl && buyEl.getBoundingClientRect(); return !!(r && r.width > 0 && r.height > 0 && r.bottom <= 0); }
  watchBuy();

  /* ---------- auto-open ---------- */
  function canAuto() {
    var st = state();
    if (st.joined) return false;
    var last = Math.max(st.autoOpenedAt || 0, st.dismissedAt || 0);
    if (last && Date.now() - last < RESHOW) return false;
    return (st.autoOpens || 0) < MAX_OPENS;
  }
  var noAuto = dlg.getAttribute('data-no-auto') === '1' || !storageOk || demo;
  var fired = false, pct = 0, retryT = 0;
  function secs() { return (Date.now() - t0) / 1000; }
  function due() {
    if (isPdp) { pastBuy = isPast(); return pastBuy && secs() >= pdpS; }
    if (mqWide.matches) return secs() >= deskS;
    return pct >= 0.25 && secs() >= (mqPhone.matches ? phoneS : deskS);
  }
  function blocked() { return cartCount > 0 || otherLayerOpen() || dlg.open || (Date.now() - lastBuy < QUIET_MS); }
  function autoOpen(trigger) {
    if (fired || noAuto || !canAuto() || session('tame_popup_snooze')) return;
    if (blocked()) { if (cartCount === 0 && trigger === 'auto' && !retryT) retryT = window.setTimeout(function () { retryT = 0; check(); }, 3000); return; }
    fired = true;
    whenConsentQuiet(function () {
      if (!canAuto() || blocked()) { fired = false; return; }
      if (open(trigger)) { var st = state(); st.autoOpens = (st.autoOpens || 0) + 1; st.autoOpenedAt = Date.now(); save(st); }
      else fired = false;
    });
  }
  function check() { if (!fired && due()) autoOpen('auto'); }
  if (!noAuto && canAuto() && !session('tame_popup_snooze')) {
    scrollFns.push(function (s) { pct = Math.max(pct, s.y / s.max); check(); });
    [phoneS, deskS, pdpS].forEach(function (n) { window.setTimeout(check, n * 1000 + 50); });
    /* exit intent: a fine pointer at 990px and up, never before 6 s */
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 0 || !mqWide.matches || secs() < 6) return;
      if (!window.matchMedia('(pointer: fine)').matches) return;
      autoOpen('exit');
    });
  }

  /* ---------- the tab ---------- */
  var tabOn = false, tabHideT = 0, tabVisT = 0, downTuck = false;
  function tabOk() {
    if (!tab) return false;
    var st = state();
    return !st.joined && !(st.tabHiddenAt && Date.now() - st.tabHiddenAt < RESHOW) && !session('tame_popup_own') && !dlg.open;
  }
  var BARS = '[data-sticky].is-on, [data-bbar].is-on, .bbar.is-on, .sticky-add-to-cart__bar, [data-v3-sticky], [data-lead-sticky], [data-tpr-sticky], [data-tws-sticky]';
  function barTop() { /* the top edge of any visible bar fixed to the bottom of the screen */
    var top = window.innerHeight;
    document.querySelectorAll(BARS).forEach(function (b) {
      if (!visible(b)) return;
      var r = b.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom >= window.innerHeight - 4 && r.top > window.innerHeight * 0.5) top = Math.min(top, r.top);
    });
    return top;
  }
  var AVOID = '[data-preset], .tlp-card, [data-b-add], [data-cart-label], ' + BARS;
  function placeTab() { /* returns false when no corner is clear */
    var bottom = window.innerHeight - barTop();
    tab.style.bottom = bottom > 0 ? (bottom + 8) + 'px' : 'calc(12px + env(safe-area-inset-bottom))';
    if (mqPhone.matches) { tab.classList.remove('is-right'); return true; }
    var w = tab.offsetWidth, h = tab.offsetHeight, by = window.innerHeight - (bottom > 0 ? bottom + 8 : 12);
    var avoid = Array.prototype.filter.call(document.querySelectorAll(AVOID), function (n) { return visible(n) && !tab.contains(n); }).map(function (n) { return n.getBoundingClientRect(); });
    var hits = function (x) { return avoid.some(function (r) { return r.left < x + w && r.right > x && r.top < by && r.bottom > by - h; }); };
    if (!hits(12)) { tab.classList.remove('is-right'); return true; }
    if (!hits(window.innerWidth - 12 - w)) { tab.classList.add('is-right'); return true; }
    return false;
  }
  function tabShow(on, force) {
    if (!tab) return;
    window.clearTimeout(tabVisT);
    if (on && (tabReady || force) && tabOk()) {
      tab.hidden = false; tab.inert = false; tab.style.visibility = '';
      if (!placeTab()) { on = false; }
    } else on = false;
    if (on) { tab.classList.remove('is-tucked'); tabOn = true; return; }
    tabOn = false;
    if (tab.hidden) return;
    tab.classList.add('is-tucked'); tab.inert = true;
    tabVisT = window.setTimeout(function () { if (!tabOn) tab.style.visibility = 'hidden'; }, 320);
  }
  var tabReady = false;
  function tabSoon() { if (tabReady && !mqPhone.matches) tabShow(true); }
  if (tab) {
    tab.classList.add('is-tucked'); tab.inert = true;
    var tabX = tab.querySelector('[data-tpop-tab-x]'); var tabOpen = tab.querySelector('[data-tpop-tab-open]');
    if (tabOpen) tabOpen.addEventListener('click', function () { if (!otherLayerOpen()) open('tab'); });
    if (tabX) tabX.addEventListener('click', function () {
      var st = state(); st.tabHiddenAt = Date.now(); save(st); tabShow(false); tab.hidden = true;
      var m = document.querySelector('main') || document.getElementById('MainContent'); if (m && !m.hasAttribute('tabindex')) m.setAttribute('tabindex', '-1'); focusEl(m);
    });
    var phonePdp = isPdp; /* R14-A3: no tab on a phone product page (tame-overrides.css hides it too) */
    window.setTimeout(function () {
      if (!tabOk()) return;
      whenConsentQuiet(function () { drawArm(); tabReady = true; tab.hidden = false; tab.style.visibility = 'hidden'; if (!mqPhone.matches) tabShow(true); });
    }, 5000);
    /* direction is judged on the distance travelled since the last turn, not per frame: smooth scrolling and trackpads move a few
       px per frame, so a per-frame 8px test never sees a scroll up */
    var lastY = scrollInfo().y, upRun = 0, downRun = 0;
    scrollFns.push(function (s) {
      if (!tabReady) { lastY = s.y; return; }
      var dy = s.y - lastY; lastY = s.y;
      if (dy > 0) { downRun += dy; upRun = 0; } else if (dy < 0) { upRun -= dy; downRun = 0; }
      if (mqPhone.matches) {
        if (phonePdp) return;
        var nearEnd = s.max - s.y < 200;
        if (downRun > 2 && !nearEnd) tabShow(false);
        else if ((upRun >= 8 && s.y > 300) || nearEnd) tabShow(true);
        window.clearTimeout(tabHideT);
        tabHideT = window.setTimeout(function () { if (!(scrollInfo().max - scrollInfo().y < 200)) tabShow(false); }, 2500);
      } else {
        /* tucks on a scroll down, back on a scroll up; every frame re-checks the corners, so it never sits on a card */
        if (downRun > 8 && s.y > 200) downTuck = true; else if (upRun >= 8 || s.y < 40) downTuck = false;
        tabShow(!downTuck);
      }
    });
    window.addEventListener('resize', function () { if (tabReady && !mqPhone.matches) tabShow(!downTuck); else if (tabOn && !placeTab()) tabShow(false); });
  }
})();
